var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBicycleModeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#4B33A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6875 22C25.9829 22 25.2941 22.2089 24.7083 22.6004C24.1224 22.9918 23.6658 23.5482 23.3962 24.1992C23.1265 24.8502 23.056 25.5665 23.1935 26.2575C23.3309 26.9486 23.6702 27.5833 24.1684 28.0816C24.6667 28.5798 25.3014 28.9191 25.9925 29.0565C26.6835 29.194 27.3999 29.1235 28.0508 28.8538C28.7018 28.5842 29.2582 28.1276 29.6496 27.5417C30.0411 26.9559 30.25 26.2671 30.25 25.5625C30.247 24.6186 29.8707 23.7142 29.2033 23.0467C28.5358 22.3793 27.6314 22.003 26.6875 22ZM14.3125 22C13.6079 22 12.9191 22.2089 12.3333 22.6004C11.7474 22.9918 11.2908 23.5482 11.0212 24.1992C10.7515 24.8502 10.681 25.5665 10.8185 26.2575C10.9559 26.9486 11.2952 27.5833 11.7934 28.0816C12.2917 28.5798 12.9264 28.9191 13.6175 29.0565C14.3085 29.194 15.0248 29.1235 15.6758 28.8538C16.3268 28.5842 16.8832 28.1276 17.2746 27.5417C17.6661 26.9559 17.875 26.2671 17.875 25.5625C17.872 24.6186 17.4957 23.7142 16.8283 23.0467C16.1608 22.3793 15.2564 22.003 14.3125 22Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 25.375V21.3438L17.5 19.375L21.25 15.25L23.125 18.625H25.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 14.875C23.6976 14.8757 23.8933 14.8372 24.0759 14.7618C24.2585 14.6864 24.4244 14.5755 24.5639 14.4356C24.7033 14.2957 24.8137 14.1295 24.8886 13.9466C24.9634 13.7638 25.0013 13.5679 25 13.3704C25.0022 13.1738 24.9652 12.9787 24.8911 12.7966C24.817 12.6145 24.7074 12.449 24.5686 12.3098C24.4298 12.1706 24.2646 12.0604 24.0828 11.9858C23.9009 11.9111 23.706 11.8735 23.5094 11.875C23.3124 11.8744 23.1172 11.9126 22.935 11.9874C22.7528 12.0622 22.5871 12.1722 22.4473 12.3111C22.1652 12.5915 22.0059 12.9725 22.0047 13.3704C22.0034 13.7682 22.1603 14.1502 22.4407 14.4324C22.7211 14.7146 23.1022 14.8738 23.5 14.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycleModeSelected);
export default __webpack_public_path__ + "static/media/bicycleModeSelected.d86d0362dfeffbadb44fec7bc181c0f8.svg";
export { ForwardRef as ReactComponent };